<template>
  <div class="personal-view">
    <div class="menu">
      <menu-list></menu-list>
    </div>
    <div class="content">
      <div class="left-nav">
        <sidebar-two :defaultActive="defaultActive" :title="sidebarTwoTitle" :list="sidebarTwoList" @selectMenu="selectMenu"></sidebar-two>
      </div>
      <div class="right-middle">
        <ul>
          <li v-for="(item, index) in dataList" :key="index">
            <div class="dataContent">
              <img :src="item.imgUrl" alt="" @click="clickImg(item)">
              <p>
                <strong>
                  {{item.text}}
                </strong>
              </p>
            </div>
          </li>
        </ul>
        <div class="pagination">
          <el-pagination
            background
            @current-change="handleCurrentChange"
            :current-page.sync="currentPage"
            :page-size="pageSize"
            layout="prev, pager, next, jumper"
            :total="total">
          </el-pagination>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import Menu from '@/base/menu/menu'
import SidebarTwo from '@/base/sidebar2/sidebar2'
import NavMenu from '@/base/navmenu/navmenu'
export default {
  name: '',
  components: {
    'menu-list': Menu,
    'sidebar-two': SidebarTwo,
    'nav-menu': NavMenu
  },
  data () {
    return {
      activeIndex: '0',
      pageSize: 10,
      total: 0,
      xmImg: require('@/assets/images/xm/xm.png'),
      gwc1: require('@/assets/images/fl/gwc1.png'),
      gwc2: require('@/assets/images/fl/gwc2.png'),
      star1: require('@/assets/images/fl/star1.png'),
      star2: require('@/assets/images/fl/star2.png'),
      currentPage: 2,
      sidebarTwoTitle: '活动·主题',
      defaultActive: '1',
      sidebarTwoList: [{
        id: '1',
        text: '主题'
      }, {
        id: '2',
        text: '活动'
      }],
      dataList: []
    }
  },
  methods: {
    selectMenu (obj) {
      this.defaultActive = obj.id
      this.getSubject(0)
    },
    handleCurrentChange (val) { // 分页
      const start = (val - 1) * this.pageSize
      this.getSubject(start)
    },
    getSubject (start) {
      const pageSize = this.pageSize
      const type = this.defaultActive
      const par = `?start=${start}&num=${pageSize}&type=${type}`
      this.$get(this.$allUrl.getSubject + par).then(res => {
        if (res.code === '0') {
          const list = res.data
          const imgAdmin = this.$allUrl.imgAdmin
          this.dataList = []
          this.total = res.recordsTotal
          list.forEach(e => {
            this.dataList.push({
              id: e.subjectId,
              imgUrl: imgAdmin + e.banner,
              text: e.subjectName,
              url: e.url
            })
          })
        }
      })
    },
    clickImg (item) { // 点击操作
      if (item.url) {
        window.open(item.url)
      } else {
        this.$router.push({
          name: 'ThemeDetails',
          query: {
            subjectId: item.id,
            text: item.text
          }
        })
      }
    }
  },
  mounted () {
    this.getSubject(0)
  }
}
</script>
<style lang="less" scoped>
  .personal-view{
    .menu{
      margin: 20px auto;
      width: 600px;
    }
    .content{
      display: flex;
      .left-nav{
        width: 200px;
      }
      .right-middle{
        flex: 1;
        margin-left: 20px;
        ul{
          list-style: none;
          margin: 0;
          padding: 0;
          display: flex;
          flex-wrap: wrap;
          li{
            max-width: 50%;
            min-width: 50%;
            .dataContent{
              padding: 0 50px 20px 50px;
              img{
                width: 100%;
                height: 200px;
                display: block;
                cursor: pointer;
              }
              p{
                padding: 0;
                margin: 0;
                text-align: center;
                border-bottom: 1px solid #DDDDDD;
                line-height: 40px;
                font-size: 14px;
                overflow: hidden;
                text-overflow:ellipsis;
                white-space: nowrap;
              }
            }
          }
        }
        .pagination{
          text-align: right;
          padding: 30px 0;
        }
      }
    }
  }
</style>
<style>
  .el-pagination.is-background .el-pager li:not(.disabled).active{
      background: #B7151E !important;
  }
</style>



// WEBPACK FOOTER //
// src/components/Theme/theme.vue


// WEBPACK FOOTER //
// src/components/Theme/theme.vue